import React, { Component } from "react"
import styled from "styled-components"
import { v4 } from 'uuid'
import { Link } from "gatsby"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ArrowIcon from "../../components/Icons/ArrowIcon"
import LeftArrowIcon from "../../components/Icons/LeftArrowIcon"
import Img from 'gatsby-image'
import BreakpointUp from "../../components/Media/BreakpointUp"

const Card = styled.div`
	margin-bottom:30px;
	display:flex;
	flex-direction:column;
	align-items:center;
	background: #fff;
	position:relative;
`
const CardTip = styled.div`
	background-color:${props=>props.bgColor};
	color:${props=>props.color};
	font-size:14px;
	line-height:18px;
	font-weight:700;
	padding:5px 15px;
	position:absolute;
	z-index:1;
	left:0;
	top:10px;
`
CardTip.defaultProps = {
	color:"#2F9800",
	bgColor:"rgba(47, 152, 0, 0.14)",
}

const CardFigure = styled.div`
	position:relative;
	width:100%;
	max-height: 350px;
	height: 100%;
	& .gatsby-image-wrapper{
		height:100%;
	}
`
const CardCaption = styled.div`
	display:flex;
	align-items:center;
	justify-content: space-between;
	position:absolute;
	bottom:0;
	left:0;
	right:0;
	background: -moz-linear-gradient(top,  rgba(0,0,0,0) 0%, rgba(0,0,0,0) 1%, rgba(2,3,4,1) 99%, rgba(2,3,4,1) 100%);
	background: -webkit-linear-gradient(top,  rgba(0,0,0,0) 0%,rgba(0,0,0,0) 1%,rgba(2,3,4,1) 99%,rgba(2,3,4,1) 100%);
	background: linear-gradient(to bottom,  rgba(0,0,0,0) 0%,rgba(0,0,0,0) 1%,rgba(2,3,4,1) 99%,rgba(2,3,4,1) 100%);
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#020304',GradientType=0 );
	padding: 0 0 15px 15px;
	${BreakpointUp.lg`
		padding: 25px 0 25px 25px;
	`}
`
const CardTitle = styled.div`
	color:#fff;
	font-weight:700;
	font-family: 'IBM Plex Serif', serif;
	font-size:20px;
	line-height:28px;
	${BreakpointUp.lg`
		font-size:24px;
		line-height:32px;
	`}

`
const CardArrow = styled.div`
	width:50px;
	height:50px;
	background-color:#020304;
	text-align:center;
	display:flex;
	align-items:center;
	justify-content: center;
	svg{
		fill:#fff;
	}
	&:hover{
		background-color:#fff;
			svg{
				fill:#020304;
			}
	}
`

// Wrapper around each slide so the existing card keeps its spacing
// consistent with the grid gap it used before.
const SlickItem = styled.div`
	display:block !important;
	outline:none;
	padding:0 8px;
`

// Centered, non-stretched layout for the single-card case so one card
// keeps roughly the width it would have in a 3-column desktop layout.
const SingleCardWrap = styled.div`
	display:flex;
	justify-content:center;
	> a{
		display:block;
		width:100%;
		padding:0 8px;
		${BreakpointUp.md`
			width:33.3333%;
		`}
	}
`

const SliderContent = styled.div`
	position:relative;
`
const SliderNav = styled.div`
	display:flex;
	align-items:center;
	justify-content:center;
	margin-top:0;
	> div + div{
		margin-left:20px;
	}
`
const NavArrow = styled.div`
	display:flex;
	align-items:center;
	justify-content:center;
	width:40px;
	height:40px;
	border-radius:50px;
	background:#fff;
	border:1px solid #ddd;
	text-align:center;
	cursor:pointer;
	& svg{
		transition: all .3s ease;
		fill:#020304;
	}
	&:hover{
		border:1px solid #020304;
	}
	&:hover svg{
		transform: translateX(${props => props.dir === "prev" ? "-5px" : "5px"});
	}
`

const RoofCard = ({ item }) => (
	<Card className="card">
		{item.heading.indexOf("Vertical")>-1? (<CardTip color="#2F9800" bgColor="#d5eacc">Best</CardTip>):(<></>)}
		{item.heading.indexOf("A-Frame")>-1? (<CardTip color="#216ABC" bgColor="#d3e1f2">Better</CardTip>):(<></>)}
		{item.heading.indexOf("Regular")>-1? (<CardTip color="#DE5600" bgColor="#f8ddcc">Good</CardTip>):(<></>)}
		<CardFigure>
			<Img fluid={item.image.fluid} />
		</CardFigure>
		<CardCaption>
			<CardTitle>{item.heading}</CardTitle>
			<CardArrow><ArrowIcon /></CardArrow>
		</CardCaption>
	</Card>
)

// Cards visible per breakpoint. These mirror the react-slick `responsive`
// settings below so arrow/autoplay logic stays in sync with what is rendered.
//   desktop (>=992px): 3   tablet (768-991px): 2   mobile (<=767px): 1
const getVisibleCount = () => {
	if (typeof window === "undefined") {
		return 3 // SSR default: assume desktop
	}
	if (window.matchMedia("(max-width: 767px)").matches) {
		return 1
	}
	if (window.matchMedia("(max-width: 991px)").matches) {
		return 2
	}
	return 3
}

export default class ProductRoofType extends Component {
	constructor(props) {
		super(props)
		this.state = {
			visibleCount: 3, // matches SSR default; corrected on mount
		}
		this.next = this.next.bind(this)
		this.previous = this.previous.bind(this)
		this.updateVisibleCount = this.updateVisibleCount.bind(this)
	}
	componentDidMount() {
		this.updateVisibleCount()
		if (typeof window !== "undefined") {
			window.addEventListener("resize", this.updateVisibleCount)
		}
	}
	componentWillUnmount() {
		if (typeof window !== "undefined") {
			window.removeEventListener("resize", this.updateVisibleCount)
		}
	}
	updateVisibleCount() {
		const visibleCount = getVisibleCount()
		if (visibleCount !== this.state.visibleCount) {
			this.setState({ visibleCount })
		}
	}
	next() {
		this.slider.slickNext()
	}
	previous() {
		this.slider.slickPrev()
	}
	render() {
		const { data } = this.props
		const items = data || []

		// No data: render nothing rather than a broken/empty slider.
		if (items.length === 0) {
			return null
		}

		// Single card: center it without stretching, no slider / no arrows / no autoplay.
		if (items.length === 1) {
			const item = items[0]
			return (
				<SingleCardWrap>
					<Link to={item.link}>
						<RoofCard item={item} />
					</Link>
				</SingleCardWrap>
			)
		}

		// Only slide (autoplay + arrows) when there are more cards than fit in
		// the current viewport: desktop >3, tablet >2, mobile >1.
		const { visibleCount } = this.state
		const shouldSlide = items.length > visibleCount

		const slidesToShow = Math.min(items.length, 3)
		const settings = {
			dots: false,
			arrows: false,
			infinite: shouldSlide,
			autoplay: shouldSlide,
			autoplaySpeed: 3000,
			pauseOnHover: true,
			speed: 300,
			slidesToShow: slidesToShow,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 991,
					settings: {
						slidesToShow: Math.min(items.length, 2),
						slidesToScroll: 1,
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					}
				}
			]
		}

		return (
			<SliderContent>
				<Slider {...settings} ref={c => (this.slider = c)}>
					{
						items.map((item) => {
							return (
								<SlickItem key={v4()}>
									<Link to={item.link}>
										<RoofCard item={item} />
									</Link>
								</SlickItem>
							)
						})
					}
				</Slider>
				{shouldSlide && (
					<SliderNav>
						<NavArrow dir="prev" onClick={this.previous} aria-label="Previous">
							<LeftArrowIcon fill="#020304" />
						</NavArrow>
						<NavArrow dir="next" onClick={this.next} aria-label="Next">
							<ArrowIcon fill="#020304" />
						</NavArrow>
					</SliderNav>
				)}
			</SliderContent>
		)
	}
}
